import TaxiCorporationOrderBillingsListResponse, {
  TaxiCorporationOrderBillingsListResponseDataItem,
  TaxiCorporationOrderBillingsListResponseDataItemBillingModel,
  TaxiCorporationOrderBillingsListResponseDataItemBillingType,
  TaxiCorporationOrderBillingsListResponseDataStats,
} from "../../../../api/raily/taxi-corporation/order-billings/list/taxi-corporation-order-billings-list.response";
import BillingModel from "../../../../types/billing-model";
import TaxiCorporationBillingType from "../../../../types/taxi-corporation-billing-type";
import TaxiCorporationOrderBillingsList, {
  TaxiCorporationOrderBillingsListItem,
  TaxiCorporationOrderBillingsListStats,
} from "./taxi-corporation-order-billings-list";

const createDataItemBillingModel = (
  type: TaxiCorporationOrderBillingsListResponseDataItemBillingModel,
): BillingModel => {
  switch (type) {
    case TaxiCorporationOrderBillingsListResponseDataItemBillingModel.AB:
      return BillingModel.AB;
    case TaxiCorporationOrderBillingsListResponseDataItemBillingModel.ABA:
      return BillingModel.ABA;
    case TaxiCorporationOrderBillingsListResponseDataItemBillingModel.OTHER:
      return BillingModel.OTHER;
    case TaxiCorporationOrderBillingsListResponseDataItemBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItemBillingType = (
  type: TaxiCorporationOrderBillingsListResponseDataItemBillingType,
): TaxiCorporationBillingType => {
  switch (type) {
    case TaxiCorporationOrderBillingsListResponseDataItemBillingType.PRIV_CARGO_2_TAXI:
      return TaxiCorporationBillingType.PRIV_CARGO_2_TAXI;
    case TaxiCorporationOrderBillingsListResponseDataItemBillingType.PRIV_TAXI_2_RAILY:
      return TaxiCorporationBillingType.PRIV_TAXI_2_RAILY;
    case TaxiCorporationOrderBillingsListResponseDataItemBillingType.PUB_RAILY_2_TAXI:
      return TaxiCorporationBillingType.PUB_RAILY_2_TAXI;
  }
};

const createDataItem = (
  dataItem: TaxiCorporationOrderBillingsListResponseDataItem,
): TaxiCorporationOrderBillingsListItem => {
  return {
    allContributionsAmount: dataItem.allContributionsAmount,
    amountForChargeHaltings: dataItem.amountForChargeHaltings,
    amountForChargeHighways: dataItem.amountForChargeHighways,
    amountForDistance: dataItem.amountForDistance,
    baseDistanceRate: dataItem.baseDistanceRate,
    billingModel: createDataItemBillingModel(dataItem.billingModel),
    billingType: createDataItemBillingType(dataItem.billingType),
    cargoCompany: dataItem.cargoCompany,
    date: dataItem.date,
    distance: dataItem.distance,
    externalId: dataItem.externalId,
    humanId: dataItem.humanId,
    id: dataItem.id,
    passengers: dataItem.passengers,
    planEntryHumanIds: dataItem.planEntryHumanIds,
    responsibleTaxi: dataItem.responsibleTaxi,
    status: dataItem.status,
    sumOfDiscounts: dataItem.sumOfDiscounts,
  };
};

const createData = (
  data: TaxiCorporationOrderBillingsListResponseDataItem[],
): TaxiCorporationOrderBillingsListItem[] => {
  return data.map(createDataItem);
};

const createStats = (
  stats: TaxiCorporationOrderBillingsListResponseDataStats,
): TaxiCorporationOrderBillingsListStats => {
  return {
    allContributionsAmount: stats.allContributionsAmount,
    amountForChargeHaltings: stats.amountForChargeHaltings,
    amountForChargeHighways: stats.amountForChargeHighways,
    amountForDistance: stats.amountForDistance,
    distance: stats.distance,
    sumOfDiscounts: stats.sumOfDiscounts,
  };
};

const create = (
  response: TaxiCorporationOrderBillingsListResponse,
): TaxiCorporationOrderBillingsList => {
  const data = response.data;
  return {
    data: createData(data.data),
    stats: createStats(data.stats),
    totalCount: data.totalCount,
  };
};

const taxiCorporationORderBillingsListFactory = {
  create,
};

export default taxiCorporationORderBillingsListFactory;
